
import React, {Component} from 'react';
import {connect} from 'react-redux'
import {Modal,ButtonToolbar,Button} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import {Radio,RadioGroup} from 'react-icheck'
import WorkdocStore from 'stores/WorkdocStore'

class NewDocFormModal extends Component {

  constructor(...args){
    super(...args)
    this.state = {data:[],loading:false,newDoc:true,filterType:'all',priceOnListType:'showprice',docName:'',docType:'',workNo:''}
  }

  loadData(props){
    this.setState(Object.assign({loading:true,show:true},props))
    let that = this
    WorkdocStore.loadDocRecord(props.workNo,props.docType,function(result){
      if(result.data.length>0)
        that.setState({loading:false,data:result.data,newDoc:false})
      else
        that.setState({loading:false,data:[],newDoc:true})
    },function(){
      that.setState({loading:false,newDoc:true,data:[]})
    })
  }

  onConfirmClick(){
    let {filterType,priceOnListType,onNewDoc} = this.state
    console.log('confirm',filterType,priceOnListType)
    if(onNewDoc !==undefined){
      this.state.onNewDoc(filterType,priceOnListType)
    }
    this.onHide()
  }

  onNewClick(){
    this.setState({newDoc:true})
  }

  onRowClick(item){
    let {onRowClick} = this.state
    if(onRowClick !==undefined){
      this.state.onRowClick(item.invoice_no)
    }
    this.onHide()
  }

  onFilterRadioChange(e,value){
    
    this.setState({filterType:value})
  }

  onPriceRadioChange(e,value){
    this.setState({priceOnListType:value})
  }

  onHide(){
    this.setState({show:false})
  }

  renderTableData(){
    let {data} = this.state

    return data.map((item,index)=>{
      return (<tr key={index} onClick={this.onRowClick.bind(this,item)}>
        <td>{item.invoice_date}</td>
        <td>{item.invoice_no}</td>
        <td>{item.amount}</td>
        <td>{item.remark}</td>
      </tr>)
    })
  }

  renderTable(){
    let {messages} = this.props
    return (
      <table className="table table-responsive table-bordered-solid table-hover">
      <thead>
          <tr>              
              <th>{messages['Date']}</th>
              <th>{messages['Document Number']}</th>                                            
              <th>{messages['Value']}</th> 
              <th>{messages['Note']}</th>
          </tr>
      </thead>
      <tbody>
          {this.renderTableData()}
      </tbody>
      <tfoot>
          <tr>              
              <th>{messages['Date']}</th>
              <th>{messages['Document Number']}</th>                                            
              <th>{messages['Value']}</th> 
              <th>{messages['Note']}</th>
          </tr>
      </tfoot>
  </table>
    )
  }

  renderNewDocOption(){
    let {messages} = this.props
    let {docName,workNo,filterType,priceOnListType} = this.state   
    let message = messages['Want to create']+docName+messages['From worksheet']+' '+workNo
    return (<div>
      <div>{message}</div><br/>
      <div>{messages['Select Item']}</div>
      <RadioGroup name="radio" value={filterType} onChange={this.onFilterRadioChange.bind(this)}>
        <Radio
          value="all"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' '+messages['Wages And Parts']}
        />
        <Radio
          value="wage"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' '+messages['Wages Only']}
        />
        <Radio
          value="part"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' '+messages['Parts Only']}          
        />
      </RadioGroup>
      <div>{messages['Show Price']}</div>
      <RadioGroup name="radio" value={priceOnListType} onChange={this.onPriceRadioChange.bind(this)}>
        <Radio
          value="showprice"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' '+messages['Show Price In Item']}
        />
        <Radio
          value="showsummary"
          radioClass="iradio_square-blue"
          increaseArea="20%"
          label={' '+messages['Don Show Price']}
        />
       
      </RadioGroup>
    </div>)
  }

  renderBody(){
    let {loading,newDoc} = this.state    
    let {messages} = this.props
    if(loading){
      return (<div>{messages['Fetching']+'...'}</div>)
    }

    if(newDoc){
      return this.renderNewDocOption()
    }else{
      return this.renderTable()
    }
  }

  render(){
    let {messages} = this.props
    let {show,newDoc,loading} = this.state
    let title = newDoc?messages['Confirm']+' ':messages['Found Item Created']+' '+messages['View Document']
    if(loading){
      title = '...'
    }
    return (
      <Modal show={show} enforceFocus={false} onHide={this.onHide.bind(this)} dialogClassName="smallwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{title} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {this.renderBody()}
        </Modal.Body>
        <Modal.Footer>
          <ButtonToolbar className='pull-right'>
            <Button style={{display:newDoc?'none':'block'}} bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name='file-text-o'/>&nbsp;{messages['Create New Document']}</Button>
            <Button style={{display:newDoc?'block':'none'}} bsStyle={'primary'} onClick={this.onConfirmClick.bind(this)}><FontAwesome name='file-text-o'/>&nbsp;{messages['OK']}</Button>
            <Button onClick={this.onHide.bind(this)}><FontAwesome name='close'/>&nbsp;{messages['Close']}</Button>
          </ButtonToolbar>
        </Modal.Footer>
      </Modal>
    )
  }
}

export default NewDocFormModal = connect(
  (state) => ({messages: state.message.view.workdoc.NewDocFormModal}),null,null,{withRef:true}
)(NewDocFormModal);





// WEBPACK FOOTER //
// ./src/view/workdoc/fast/NewDocFormModal.js